module.exports = __webpack_public_path__ + "static/img/success4.4b2b914f.png";